import Http from './../http';

const prefix = '/website-user';

const encodeDataToURL = data => {
  return Object.keys(data)
    .map(value => `${value}=${encodeURIComponent(data[value])}`)
    .join('&');
};

export const getAll = (website_id, page = 1, filters = 0) =>{
  return Http.authApi().get(`${prefix}/all/${website_id}?page=${page}&${encodeDataToURL(filters)}`)
};

export const get = ({ id }) => Http.authApi().get(`${prefix}/${id}`);

export const create = websiteUser => Http.authApi().post(`${prefix}`, websiteUser);

export const edit = websiteUser => Http.authApi().put(`${prefix}/${websiteUser.encrypted_id}`, websiteUser);

export const editPermissionsManyUsers = data => Http.authApi().post(`${prefix}/users-update-permissions`, data);

export const editPassword = websiteUser => Http.authApi().post(`${prefix}/user-update-password`, websiteUser);

export const exclude = websiteUser => Http.authApi().delete(`${prefix}/${websiteUser.encrypted_id}`, websiteUser);

export const excludeManyUsers = data => Http.authApi().post(`${prefix}/users-mass-deletion`, data);

export const importUsersPrepare = data => Http.authApi().post(`${prefix}/import-users-prepare`, data, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

export const importUsers = data => Http.authApi().post(`${prefix}/import-users`, data);

export const exportUsers = data => Http.authApi().post(`${prefix}/export-users`, data, {
  responseType: 'blob'
});



// WEBPACK FOOTER //
// ./src/js/services/restrictArea/websiteUsers.js